import { Fragment, useState } from "react";
import classes from "../hpschedulingdetails/HpSchedulingDetails.module.css";
import globalClasses from "../../../commoncomponents/css/Global.module.css";
import InputField from "../../../commoncomponents/input/InputField";
import SelectField from "../../../commoncomponents/dropdown/SelectField";
import { TIMINGSLOTDURATION } from "./HpSchedulingDetailsDummyData";
import ButtonComponent from "../../../commoncomponents/buttons/ButtonComponent";
import TimeComponent from "../../../commoncomponents/input/TimeComponent";
import {
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
  Backdrop,
  CircularProgress,
  Stack,
} from "@mui/material";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import { ErrorMessage, FieldArray, FormikProvider, getIn } from "formik";
import { nanoid } from "nanoid";

const HpScheduleTimings = ({
  formik,
  resetField,
}: {
  formik: any;
  resetField: any;
}) => {
  const [disableDefaultCheck, setDisableDefaultCheck] = useState(false);
  const [open, setOpen] = useState(false);

  //This function used to Reset values for Hp Schedule Timings tabs
  const ResetSelectedValue = (formik: any, weekIndex: any, day: any) => {
    formik.setFieldValue(`${day}[${weekIndex}].numberOfAppointment`, "");
    formik.setFieldValue(`${day}[${weekIndex}].duration`, "");
    formik.setFieldValue(`${day}[${weekIndex}].startTime`, null);
    formik.setFieldValue(`${day}[${weekIndex}].endTime`, null);
    formik.setFieldValue(`${day}[${weekIndex}].setAsDefault`, false);
  };

  const ResetNonDefault = (arrayHelpers: any) => {
    let days = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];
    days.forEach((element: any) => {
      arrayHelpers?.form?.values?.[element].length > 1 &&
        arrayHelpers?.form?.values?.[element].splice(1) &&
        arrayHelpers.remove(1);
    });
  };

  //This function used to setDefault values for other tabs and set as checked
  const SetAllDefaultTab = async (
    formik: any,
    value: any,
    weekIndex: any,
    day: number
  ) => {
    let days = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];

    days.splice(day, 1);
    await days.forEach((element) => {
      formik.setFieldValue(
        `${element}[${weekIndex}].clinicType`,
        value.clinicType
      );

      formik.setFieldValue(
        `${element}[${weekIndex}].clinicLocation`,
        value.clinicLocation
      );
      formik.setFieldValue(
        `${element}[${weekIndex}].numberOfAppointment`,
        value.numberOfAppointment
      );
      formik.setFieldValue(`${element}[${weekIndex}].duration`, value.duration);
      formik.setFieldValue(
        `${element}[${weekIndex}].startTime`,
        value.startTime
      );
      formik.setFieldValue(`${element}[${weekIndex}].endTime`, value.endTime);

      formik.setFieldValue(`${element}[${weekIndex}].setAsDefault`, true);
    });
    setTimeout(() => {
      setOpen(false);
    }, 5000);
  };

  const isError = (value: any) => {
    let error =
      Boolean(getIn(formik.touched, value)) &&
      Boolean(getIn(formik.errors, value));
    return error;
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="h1" className={globalClasses.typography}>
            HP Schedule Timings
          </Typography>
        </Grid>
      </Grid>
      {/** This code is for  Weekly Scheduling Tabs */}
      <Grid item container xs={12} rowGap={2} sx={styles.alignItem}>
        {/** Monday field array and add shedule code  */}
        <FormikProvider value={formik}>
          <form>
            <Grid container columnSpacing={2} rowGap={2} sx={styles.tab}>
              <Grid item xs={12} sm={12} md={12} lg={1} sx={styles.day}>
                <Typography sx={styles.dayText}>Monday</Typography>
              </Grid>
              <FieldArray
                name="monday"
                render={(arrayHelpers) => (
                  <>
                    {formik.values.monday.map((monday: any, weekIndex: any) => {
                      /** This function is used to set default values to other tabs when you select checkbox of setAs default */
                      const setAllDefault = (value: any) => {
                        SetAllDefaultTab(formik, value, weekIndex, 0);
                      };

                      resetField === true && ResetNonDefault(arrayHelpers);

                      return (
                        <Fragment key={monday.mondayId}>
                          {weekIndex !== 0 && (
                            <Grid item xs={12} sm={12} md={12} lg={1}></Grid>
                          )}
                          <Grid item xs={12} sm={6} md={4} lg={2}>
                            <InputField
                              id={`monday[${weekIndex}].numberOfAppointment`}
                              name={`monday[${weekIndex}].numberOfAppointment`}
                              label="No of appointments"
                              isrequired={true}
                              inputvalues={
                                formik.values.monday[weekIndex]
                                  .numberOfAppointment
                              }
                              changeevent={(event: any) => {
                                formik.handleChange(
                                  `monday[${weekIndex}].numberOfAppointment`
                                )(event);
                                formik.setFieldValue(
                                  `monday[${weekIndex}].setAsDefault`,
                                  false
                                );
                                formik.setFieldValue(
                                  `monday[${weekIndex}].isLeave`,
                                  false
                                );
                              }}
                              blurevent={formik.handleBlur}
                              errormessage={isError(
                                `monday[${weekIndex}].numberOfAppointment`
                              )}
                            />
                            {formik?.values?.monday[weekIndex]
                              ?.numberOfAppointment === "" &&
                              isError(
                                `monday[${weekIndex}].numberOfAppointment`
                              ) && (
                                <Typography sx={styles.errorMessage}>
                                  <ErrorMessage
                                    name={`monday[${weekIndex}].numberOfAppointment`}
                                  />
                                </Typography>
                              )}
                          </Grid>
                          <Grid item xs={12} sm={6} md={4} lg={2}>
                            <SelectField
                              id={`monday[${weekIndex}].duration`}
                              name={`monday[${weekIndex}].duration`}
                              headerText="Duration(min)"
                              label="Select Duration"
                              isrequired={true}
                              value={formik.values.monday[weekIndex].duration}
                              blurevent={formik.handleBlur}
                              changeevent={(event: any) => {
                                formik.handleChange(
                                  `monday[${weekIndex}].duration`
                                )(event);
                                formik.setFieldValue(
                                  `monday[${weekIndex}].setAsDefault`,
                                  false
                                );
                                formik.setFieldValue(
                                  `monday[${weekIndex}].isLeave`,
                                  false
                                );
                              }}
                              options={TIMINGSLOTDURATION}
                              error={
                                formik?.values?.monday[weekIndex]?.duration ===
                                  "" && isError(`monday[${weekIndex}].duration`)
                              }
                            />
                            {formik?.values?.monday[weekIndex]?.duration ===
                              "" &&
                              isError(`monday[${weekIndex}].duration`) && (
                                <Typography sx={styles.errorMessage}>
                                  <ErrorMessage
                                    name={`monday[${weekIndex}].duration`}
                                  />
                                </Typography>
                              )}
                          </Grid>
                          <Grid item xs={12} sm={6} md={4} lg={2}>
                            <TimeComponent
                              label="Start Time"
                              isrequired={true}
                              value={formik.values.monday[weekIndex].startTime}
                              onChange={(newValue: any) => {
                                formik.setFieldValue(
                                  `monday[${weekIndex}].startTime`,
                                  newValue
                                );
                                formik.setFieldValue(
                                  `monday[${weekIndex}].setAsDefault`,
                                  false
                                );
                                formik.setFieldValue(
                                  `monday[${weekIndex}].isLeave`,
                                  false
                                );
                              }}
                              error={
                                getIn(
                                  formik.touched,
                                  `monday[${weekIndex}].startTime`
                                ) &&
                                getIn(
                                  formik.errors,
                                  `monday[${weekIndex}].startTime`
                                )
                              }
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4} lg={2}>
                            <TimeComponent
                              label="End Time"
                              isrequired={true}
                              value={formik.values.monday[weekIndex].endTime}
                              onChange={(newValue: any) => {
                                formik.setFieldValue(
                                  `monday[${weekIndex}].endTime`,
                                  newValue
                                );
                                formik.setFieldValue(
                                  `monday[${weekIndex}].isLeave`,
                                  false
                                );
                                setDisableDefaultCheck(true);
                              }}
                              onClose={(event: any) => {
                                formik.setFieldValue(
                                  `monday[${weekIndex}].setAsDefault`,
                                  false
                                );
                                setDisableDefaultCheck(false);
                              }}
                              error={
                                getIn(
                                  formik.touched,
                                  `monday[${weekIndex}].endTime`
                                ) &&
                                getIn(
                                  formik.errors,
                                  `monday[${weekIndex}].endTime`
                                )
                              }
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={4}
                            lg={3}
                            sx={styles.markLeave}
                          >
                            {weekIndex === 0 && (
                              <FormControlLabel
                                className={classes.setAsDefault}
                                control={
                                  <Checkbox
                                    id={`monday[${weekIndex}].setAsDefault`}
                                    name={`monday[${weekIndex}].setAsDefault`}
                                    value={
                                      formik.values.monday[weekIndex]
                                        .setAsDefault
                                    }
                                    checked={
                                      formik.values.monday[weekIndex]
                                        .setAsDefault
                                    }
                                    disabled={disableDefaultCheck}
                                    sx={{ fontSize: "12px" }}
                                  />
                                }
                                label={
                                  <Typography variant="body2">
                                    Set As Default
                                  </Typography>
                                }
                                onChange={(event: any, newValue: any) => {
                                  formik.setFieldValue(
                                    `monday[${weekIndex}].setAsDefault`,
                                    newValue
                                  );
                                  if (
                                    !formik.values.monday[weekIndex]
                                      .setAsDefault === true
                                  ) {
                                    setOpen(true);
                                    setAllDefault(
                                      formik.values.monday[weekIndex]
                                    );
                                  }

                                  !formik.values.monday[weekIndex]
                                    .setAsDefault === true &&
                                    ResetNonDefault(arrayHelpers);
                                }}
                                onBlur={formik.handleBlur}
                              />
                            )}
                            <Stack sx={{ flexDirection: "row" }}>
                              {weekIndex !== 0 && (
                                <DeleteForeverOutlinedIcon
                                  sx={{ marginTop: "10px" }}
                                  color="error"
                                  onClick={() => {
                                    arrayHelpers.form.values.monday.length !== 1
                                      ? arrayHelpers.remove(weekIndex)
                                      : arrayHelpers.remove(1);
                                  }}
                                />
                              )}
                              {weekIndex === 0 && (
                                <ButtonComponent
                                  variant="contained"
                                  size="small"
                                  type="reset"
                                  label="Mark as leave"
                                  buttonclass={classes.resetButton}
                                  onClick={() => {
                                    formik.setFieldValue(
                                      `monday[${weekIndex}].isLeave`,
                                      true
                                    );
                                    ResetSelectedValue(
                                      formik,
                                      weekIndex,
                                      "monday"
                                    );
                                  }}
                                />
                              )}
                            </Stack>
                          </Grid>
                        </Fragment>
                      );
                    })}

                    <Grid
                      item
                      xs={12}
                      md={12}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "10px",
                      }}
                    >
                      {formik.values.monday[0].setAsDefault === false &&
                        formik.values.monday[0].isLeave === false && (
                          <ButtonComponent
                            buttonclass={globalClasses.addButton}
                            sx={{
                              maxWidth: "50px !importanat",
                              display:
                                arrayHelpers?.form?.values?.monday?.length <= 1
                                  ? "block"
                                  : "none",
                            }}
                            variant="contained"
                            label="Add"
                            onClick={(e: any) => {
                              e.preventDefault();

                              arrayHelpers.form.values.monday.length <= 1 &&
                                arrayHelpers.push({
                                  mondayId: nanoid(),
                                  isLeave: false,
                                  numberOfAppointment: "",
                                  duration: "",
                                  startTime: "",
                                  endTime: "",
                                  setAsDefault: false,
                                });
                            }}
                          />
                        )}
                    </Grid>
                  </>
                )}
              />
            </Grid>
          </form>
        </FormikProvider>

        {/** Tuesday tab field array and add shedule code  */}

        <FormikProvider value={formik}>
          <form>
            <Grid container columnSpacing={2} rowGap={2} sx={styles.tab}>
              <Grid item xs={12} sm={12} md={12} lg={1} sx={styles.day}>
                <Typography sx={styles.dayText}>Tuesday</Typography>
              </Grid>
              <FieldArray
                name="tuesday"
                render={(arrayHelpers) => (
                  <>
                    {formik.values.tuesday.map(
                      (tuesday: any, weekIndex: any) => {
                        /** This function is used to set default values to other tabs when you select checkbox of setAs default */
                        const setAllDefault = (value: any) => {
                          SetAllDefaultTab(formik, value, weekIndex, 1);
                        };
                        return (
                          <Fragment key={tuesday.tuesdayId}>
                            {weekIndex !== 0 && (
                              <Grid item xs={12} sm={12} md={12} lg={1}></Grid>
                            )}
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                              <InputField
                                id={`tuesday[${weekIndex}].numberOfAppointment`}
                                name={`tuesday[${weekIndex}].numberOfAppointment`}
                                label="No of appointments"
                                isrequired={true}
                                inputvalues={
                                  formik.values.tuesday[weekIndex]
                                    .numberOfAppointment
                                }
                                changeevent={(event: any) => {
                                  formik.handleChange(
                                    `tuesday[${weekIndex}].numberOfAppointment`
                                  )(event);
                                  formik.setFieldValue(
                                    `tuesday[${weekIndex}].setAsDefault`,
                                    false
                                  );
                                  formik.setFieldValue(
                                    `tuesday[${weekIndex}].isLeave`,
                                    false
                                  );
                                }}
                                blurevent={formik.handleBlur}
                                errormessage={isError(
                                  `tuesday[${weekIndex}].numberOfAppointment`
                                )}
                              />
                              {formik?.values?.tuesday[weekIndex]
                                ?.numberOfAppointment === "" &&
                                isError(
                                  `tuesday[${weekIndex}].numberOfAppointment`
                                ) && (
                                  <Typography sx={styles.errorMessage}>
                                    <ErrorMessage
                                      name={`tuesday[${weekIndex}].numberOfAppointment`}
                                    />
                                  </Typography>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                              <SelectField
                                id={`tuesday[${weekIndex}].duration`}
                                name={`tuesday[${weekIndex}].duration`}
                                headerText="Duration(min)"
                                label="Select Duration"
                                isrequired={true}
                                value={
                                  formik.values.tuesday[weekIndex].duration
                                }
                                blurevent={formik.handleBlur}
                                changeevent={(event: any) => {
                                  formik.handleChange(
                                    `tuesday[${weekIndex}].duration`
                                  )(event);
                                  formik.setFieldValue(
                                    `tuesday[${weekIndex}].setAsDefault`,
                                    false
                                  );
                                  formik.setFieldValue(
                                    `tuesday[${weekIndex}].isLeave`,
                                    false
                                  );
                                }}
                                options={TIMINGSLOTDURATION}
                                error={
                                  formik?.values?.tuesday[weekIndex]
                                    ?.duration === "" &&
                                  isError(`tuesday[${weekIndex}].duration`)
                                }
                              />
                              {formik?.values?.tuesday[weekIndex]?.duration ===
                                "" &&
                                isError(`tuesday[${weekIndex}].duration`) && (
                                  <Typography sx={styles.errorMessage}>
                                    <ErrorMessage
                                      name={`tuesday[${weekIndex}].duration`}
                                    />
                                  </Typography>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                              <TimeComponent
                                label="Start Time"
                                isrequired={true}
                                value={
                                  formik.values.tuesday[weekIndex].startTime
                                }
                                onChange={(newValue: any) => {
                                  formik.setFieldValue(
                                    `tuesday[${weekIndex}].startTime`,
                                    newValue
                                  );
                                  formik.setFieldValue(
                                    `tuesday[${weekIndex}].setAsDefault`,
                                    false
                                  );
                                  formik.setFieldValue(
                                    `tuesday[${weekIndex}].isLeave`,
                                    false
                                  );
                                }}
                                error={
                                  getIn(
                                    formik.touched,
                                    `tuesday[${weekIndex}].startTime`
                                  ) &&
                                  getIn(
                                    formik.errors,
                                    `tuesday[${weekIndex}].startTime`
                                  )
                                }
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                              <TimeComponent
                                label="End Time"
                                isrequired={true}
                                value={formik.values.tuesday[weekIndex].endTime}
                                onChange={(newValue: any) => {
                                  formik.setFieldValue(
                                    `tuesday[${weekIndex}].endTime`,
                                    newValue
                                  );
                                  formik.setFieldValue(
                                    `tuesday[${weekIndex}].isLeave`,
                                    false
                                  );
                                  setDisableDefaultCheck(true);
                                }}
                                onClose={(event: any) => {
                                  formik.setFieldValue(
                                    `tuesday[${weekIndex}].setAsDefault`,
                                    false
                                  );
                                  setDisableDefaultCheck(false);
                                }}
                                error={
                                  getIn(
                                    formik.touched,
                                    `tuesday[${weekIndex}].endTime`
                                  ) &&
                                  getIn(
                                    formik.errors,
                                    `tuesday[${weekIndex}].endTime`
                                  )
                                }
                              />
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              md={4}
                              lg={3}
                              sx={styles.markLeave}
                            >
                              {weekIndex === 0 && (
                                <FormControlLabel
                                  className={classes.setAsDefault}
                                  control={
                                    <Checkbox
                                      id={`tuesday[${weekIndex}].setAsDefault`}
                                      name={`tuesday[${weekIndex}].setAsDefault`}
                                      value={
                                        formik.values.tuesday[weekIndex]
                                          .setAsDefault
                                      }
                                      checked={
                                        formik.values.tuesday[weekIndex]
                                          .setAsDefault
                                      }
                                      disabled={disableDefaultCheck}
                                      sx={{ fontSize: "12px" }}
                                    />
                                  }
                                  label={
                                    <Typography variant="body2">
                                      Set As Default
                                    </Typography>
                                  }
                                  onChange={(event: any, newValue: any) => {
                                    formik.setFieldValue(
                                      `tuesday[${weekIndex}].setAsDefault`,
                                      newValue
                                    );
                                    if (
                                      !formik.values.tuesday[weekIndex]
                                        .setAsDefault === true
                                    ) {
                                      setOpen(true);
                                      setAllDefault(
                                        formik.values.tuesday[weekIndex]
                                      );
                                    }
                                    !formik.values.tuesday[weekIndex]
                                      .setAsDefault === true &&
                                      ResetNonDefault(arrayHelpers);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                              )}
                              <Stack sx={{ flexDirection: "row" }}>
                                {weekIndex !== 0 && (
                                  <DeleteForeverOutlinedIcon
                                    sx={{ marginTop: "10px" }}
                                    color="error"
                                    onClick={() => {
                                      arrayHelpers.form.values.tuesday
                                        .length !== 1
                                        ? arrayHelpers.remove(weekIndex)
                                        : arrayHelpers.remove(1);
                                    }}
                                  />
                                )}
                                {weekIndex === 0 && (
                                  <ButtonComponent
                                    variant="contained"
                                    size="small"
                                    type="reset"
                                    label="Mark as leave"
                                    buttonclass={classes.resetButton}
                                    onClick={() => {
                                      formik.setFieldValue(
                                        `tuesday[${weekIndex}].isLeave`,
                                        true
                                      );
                                      ResetSelectedValue(
                                        formik,
                                        weekIndex,
                                        "tuesday"
                                      );
                                    }}
                                  />
                                )}
                              </Stack>
                            </Grid>
                          </Fragment>
                        );
                      }
                    )}

                    <Grid
                      item
                      xs={12}
                      md={12}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "10px",
                      }}
                    >
                      {formik.values.tuesday[0].setAsDefault === false &&
                        formik.values.tuesday[0].isLeave === false && (
                          <ButtonComponent
                            buttonclass={globalClasses.addButton}
                            sx={{
                              maxWidth: "50px !importanat",
                              display:
                                arrayHelpers?.form?.values?.tuesday?.length <= 1
                                  ? "block"
                                  : "none",
                            }}
                            variant="contained"
                            label="Add"
                            onClick={(e: any) => {
                              e.preventDefault();
                              arrayHelpers.form.values.tuesday.length <= 1 &&
                                arrayHelpers.push({
                                  tuesdayId: nanoid(),
                                  isLeave: false,
                                  numberOfAppointment: "",
                                  duration: "",
                                  startTime: "",
                                  endTime: "",
                                  setAsDefault: false,
                                });
                            }}
                          />
                        )}
                    </Grid>
                  </>
                )}
              />
            </Grid>
          </form>
        </FormikProvider>

        {/** Wednesday tab field array and add shedule code  */}

        <FormikProvider value={formik}>
          <form>
            <Grid container columnSpacing={2} rowGap={2} sx={styles.tab}>
              <Grid item xs={12} sm={12} md={12} lg={1} sx={styles.day}>
                <Typography sx={styles.dayText}>Wednesday</Typography>
              </Grid>
              <FieldArray
                name="wednesday"
                render={(arrayHelpers) => (
                  <>
                    {formik.values.wednesday.map(
                      (wednesday: any, weekIndex: any) => {
                        /** This function is used to set default values to other tabs when you select checkbox of setAs default */
                        const setAllDefault = (value: any) => {
                          SetAllDefaultTab(formik, value, weekIndex, 2);
                        };
                        return (
                          <Fragment key={wednesday.wednesdayId}>
                            {weekIndex !== 0 && (
                              <Grid item xs={12} sm={12} md={12} lg={1}></Grid>
                            )}
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                              <InputField
                                id={`wednesday[${weekIndex}].numberOfAppointment`}
                                name={`wednesday[${weekIndex}].numberOfAppointment`}
                                label="No of appointments"
                                isrequired={true}
                                inputvalues={
                                  formik.values.wednesday[weekIndex]
                                    .numberOfAppointment
                                }
                                changeevent={(event: any) => {
                                  formik.handleChange(
                                    `wednesday[${weekIndex}].numberOfAppointment`
                                  )(event);
                                  formik.setFieldValue(
                                    `wednesday[${weekIndex}].setAsDefault`,
                                    false
                                  );
                                  formik.setFieldValue(
                                    `wednesday[${weekIndex}].isLeave`,
                                    false
                                  );
                                }}
                                blurevent={formik.handleBlur}
                                errormessage={isError(
                                  `wednesday[${weekIndex}].numberOfAppointment`
                                )}
                              />
                              {formik?.values?.wednesday[weekIndex]
                                ?.numberOfAppointment === "" &&
                                isError(
                                  `wednesday[${weekIndex}].numberOfAppointment`
                                ) && (
                                  <Typography sx={styles.errorMessage}>
                                    <ErrorMessage
                                      name={`wednesday[${weekIndex}].numberOfAppointment`}
                                    />
                                  </Typography>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                              <SelectField
                                id={`wednesday[${weekIndex}].duration`}
                                name={`wednesday[${weekIndex}].duration`}
                                headerText="Duration(min)"
                                label="Select Duration"
                                isrequired={true}
                                value={
                                  formik.values.wednesday[weekIndex].duration
                                }
                                blurevent={formik.handleBlur}
                                changeevent={(event: any) => {
                                  formik.handleChange(
                                    `wednesday[${weekIndex}].duration`
                                  )(event);
                                  formik.setFieldValue(
                                    `wednesday[${weekIndex}].setAsDefault`,
                                    false
                                  );
                                  formik.setFieldValue(
                                    `wednesday[${weekIndex}].isLeave`,
                                    false
                                  );
                                }}
                                options={TIMINGSLOTDURATION}
                                error={
                                  formik?.values?.wednesday[weekIndex]
                                    ?.duration === "" &&
                                  isError(`wednesday[${weekIndex}].duration`)
                                }
                              />
                              {formik?.values?.wednesday[weekIndex]
                                ?.duration === "" &&
                                isError(`wednesday[${weekIndex}].duration`) && (
                                  <Typography sx={styles.errorMessage}>
                                    <ErrorMessage
                                      name={`wednesday[${weekIndex}].duration`}
                                    />
                                  </Typography>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                              <TimeComponent
                                label="Start Time"
                                isrequired={true}
                                value={
                                  formik.values.wednesday[weekIndex].startTime
                                }
                                onChange={(newValue: any) => {
                                  formik.setFieldValue(
                                    `wednesday[${weekIndex}].startTime`,
                                    newValue
                                  );
                                  formik.setFieldValue(
                                    `wednesday[${weekIndex}].setAsDefault`,
                                    false
                                  );
                                  formik.setFieldValue(
                                    `wednesday[${weekIndex}].isLeave`,
                                    false
                                  );
                                }}
                                error={
                                  getIn(
                                    formik.touched,
                                    `wednesday[${weekIndex}].startTime`
                                  ) &&
                                  getIn(
                                    formik.errors,
                                    `wednesday[${weekIndex}].startTime`
                                  )
                                }
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                              <TimeComponent
                                label="End Time"
                                isrequired={true}
                                value={
                                  formik.values.wednesday[weekIndex].endTime
                                }
                                onChange={(newValue: any) => {
                                  formik.setFieldValue(
                                    `wednesday[${weekIndex}].endTime`,
                                    newValue
                                  );
                                  formik.setFieldValue(
                                    `wednesday[${weekIndex}].isLeave`,
                                    false
                                  );
                                  setDisableDefaultCheck(true);
                                }}
                                onClose={(event: any) => {
                                  formik.setFieldValue(
                                    `wednesday[${weekIndex}].setAsDefault`,
                                    false
                                  );
                                  setDisableDefaultCheck(false);
                                }}
                                error={
                                  getIn(
                                    formik.touched,
                                    `wednesday[${weekIndex}].endTime`
                                  ) &&
                                  getIn(
                                    formik.errors,
                                    `wednesday[${weekIndex}].endTime`
                                  )
                                }
                              />
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              md={4}
                              lg={3}
                              sx={styles.markLeave}
                            >
                              {weekIndex === 0 && (
                                <FormControlLabel
                                  className={classes.setAsDefault}
                                  control={
                                    <Checkbox
                                      id={`wednesday[${weekIndex}].setAsDefault`}
                                      name={`wednesday[${weekIndex}].setAsDefault`}
                                      value={
                                        formik.values.wednesday[weekIndex]
                                          .setAsDefault
                                      }
                                      checked={
                                        formik.values.wednesday[weekIndex]
                                          .setAsDefault
                                      }
                                      disabled={disableDefaultCheck}
                                      sx={{ fontSize: "12px" }}
                                    />
                                  }
                                  label={
                                    <Typography variant="body2">
                                      Set As Default
                                    </Typography>
                                  }
                                  onChange={(event: any, newValue: any) => {
                                    formik.setFieldValue(
                                      `wednesday[${weekIndex}].setAsDefault`,
                                      newValue
                                    );
                                    if (
                                      !formik.values.wednesday[weekIndex]
                                        .setAsDefault === true
                                    ) {
                                      setOpen(true);
                                      setAllDefault(
                                        formik.values.wednesday[weekIndex]
                                      );
                                    }
                                    !formik.values.wednesday[weekIndex]
                                      .setAsDefault === true &&
                                      ResetNonDefault(arrayHelpers);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                              )}
                              <Stack sx={{ flexDirection: "row" }}>
                                {weekIndex !== 0 && (
                                  <DeleteForeverOutlinedIcon
                                    sx={{ marginTop: "10px" }}
                                    color="error"
                                    onClick={() => {
                                      arrayHelpers.form.values.wednesday
                                        .length !== 1
                                        ? arrayHelpers.remove(weekIndex)
                                        : arrayHelpers.remove(1);
                                    }}
                                  />
                                )}
                                {weekIndex === 0 && (
                                  <ButtonComponent
                                    variant="contained"
                                    size="small"
                                    type="reset"
                                    label="Mark as leave"
                                    buttonclass={classes.resetButton}
                                    onClick={() => {
                                      formik.setFieldValue(
                                        `wednesday[${weekIndex}].isLeave`,
                                        true
                                      );
                                      ResetSelectedValue(
                                        formik,
                                        weekIndex,
                                        "wednesday"
                                      );
                                    }}
                                  />
                                )}
                              </Stack>
                            </Grid>
                          </Fragment>
                        );
                      }
                    )}

                    <Grid
                      item
                      xs={12}
                      md={12}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "10px",
                      }}
                    >
                      {formik.values.wednesday[0].setAsDefault === false &&
                        formik.values.wednesday[0].isLeave === false && (
                          <ButtonComponent
                            buttonclass={globalClasses.addButton}
                            sx={{
                              maxWidth: "50px !importanat",
                              display:
                                arrayHelpers?.form?.values?.wednesday?.length <=
                                1
                                  ? "block"
                                  : "none",
                            }}
                            variant="contained"
                            label="Add"
                            onClick={(e: any) => {
                              e.preventDefault();
                              arrayHelpers.form.values.wednesday.length <= 1 &&
                                arrayHelpers.push({
                                  wednesdayId: nanoid(),
                                  isLeave: false,
                                  numberOfAppointment: "",
                                  duration: "",
                                  startTime: "",
                                  endTime: "",
                                  setAsDefault: false,
                                });
                            }}
                          />
                        )}
                    </Grid>
                  </>
                )}
              />
            </Grid>
          </form>
        </FormikProvider>

        {/** Thursday tab field array and add shedule code  */}

        <FormikProvider value={formik}>
          <form>
            <Grid container columnSpacing={2} rowGap={2} sx={styles.tab}>
              <Grid item xs={12} sm={12} md={12} lg={1} sx={styles.day}>
                <Typography sx={styles.dayText}>Thursday</Typography>
              </Grid>
              <FieldArray
                name="thursday"
                render={(arrayHelpers) => (
                  <>
                    {formik.values.thursday.map(
                      (thursday: any, weekIndex: any) => {
                        /** This function is used to set default values to other tabs when you select checkbox of setAs default */
                        const setAllDefault = (value: any) => {
                          SetAllDefaultTab(formik, value, weekIndex, 3);
                        };
                        return (
                          <Fragment key={thursday.thursdayId}>
                            {weekIndex !== 0 && (
                              <Grid item xs={12} sm={12} md={12} lg={1}></Grid>
                            )}
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                              <InputField
                                id={`thursday[${weekIndex}].numberOfAppointment`}
                                name={`thursday[${weekIndex}].numberOfAppointment`}
                                label="No of appointments"
                                isrequired={true}
                                inputvalues={
                                  formik.values.thursday[weekIndex]
                                    .numberOfAppointment
                                }
                                changeevent={(event: any) => {
                                  formik.handleChange(
                                    `thursday[${weekIndex}].numberOfAppointment`
                                  )(event);
                                  formik.setFieldValue(
                                    `thursday[${weekIndex}].setAsDefault`,
                                    false
                                  );
                                  formik.setFieldValue(
                                    `thursday[${weekIndex}].isLeave`,
                                    false
                                  );
                                }}
                                blurevent={formik.handleBlur}
                                errormessage={isError(
                                  `thursday[${weekIndex}].numberOfAppointment`
                                )}
                              />
                              {formik?.values?.thursday[weekIndex]
                                ?.numberOfAppointment === "" &&
                                isError(
                                  `thursday[${weekIndex}].numberOfAppointment`
                                ) && (
                                  <Typography sx={styles.errorMessage}>
                                    <ErrorMessage
                                      name={`thursday[${weekIndex}].numberOfAppointment`}
                                    />
                                  </Typography>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                              <SelectField
                                id={`thursday[${weekIndex}].duration`}
                                name={`thursday[${weekIndex}].duration`}
                                headerText="Duration(min)"
                                label="Select Duration"
                                isrequired={true}
                                value={
                                  formik.values.thursday[weekIndex].duration
                                }
                                blurevent={formik.handleBlur}
                                changeevent={(event: any) => {
                                  formik.handleChange(
                                    `thursday[${weekIndex}].duration`
                                  )(event);
                                  formik.setFieldValue(
                                    `thursday[${weekIndex}].setAsDefault`,
                                    false
                                  );
                                  formik.setFieldValue(
                                    `thursday[${weekIndex}].isLeave`,
                                    false
                                  );
                                }}
                                options={TIMINGSLOTDURATION}
                                error={
                                  formik?.values?.thursday[weekIndex]
                                    ?.duration === "" &&
                                  isError(`thursday[${weekIndex}].duration`)
                                }
                              />
                              {formik?.values?.thursday[weekIndex]?.duration ===
                                "" &&
                                isError(`thursday[${weekIndex}].duration`) && (
                                  <Typography sx={styles.errorMessage}>
                                    <ErrorMessage
                                      name={`thursday[${weekIndex}].duration`}
                                    />
                                  </Typography>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                              <TimeComponent
                                label="Start Time"
                                isrequired={true}
                                value={
                                  formik.values.thursday[weekIndex].startTime
                                }
                                onChange={(newValue: any) => {
                                  formik.setFieldValue(
                                    `thursday[${weekIndex}].startTime`,
                                    newValue
                                  );
                                  formik.setFieldValue(
                                    `thursday[${weekIndex}].setAsDefault`,
                                    false
                                  );
                                  formik.setFieldValue(
                                    `thursday[${weekIndex}].isLeave`,
                                    false
                                  );
                                }}
                                error={
                                  getIn(
                                    formik.touched,
                                    `thursday[${weekIndex}].startTime`
                                  ) &&
                                  getIn(
                                    formik.errors,
                                    `thursday[${weekIndex}].startTime`
                                  )
                                }
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                              <TimeComponent
                                label="End Time"
                                isrequired={true}
                                value={
                                  formik.values.thursday[weekIndex].endTime
                                }
                                onChange={(newValue: any) => {
                                  formik.setFieldValue(
                                    `thursday[${weekIndex}].endTime`,
                                    newValue
                                  );
                                  formik.setFieldValue(
                                    `thursday[${weekIndex}].isLeave`,
                                    false
                                  );
                                  setDisableDefaultCheck(true);
                                }}
                                onClose={(event: any) => {
                                  formik.setFieldValue(
                                    `thursday[${weekIndex}].setAsDefault`,
                                    false
                                  );
                                  setDisableDefaultCheck(false);
                                }}
                                error={
                                  getIn(
                                    formik.touched,
                                    `thursday[${weekIndex}].endTime`
                                  ) &&
                                  getIn(
                                    formik.errors,
                                    `thursday[${weekIndex}].endTime`
                                  )
                                }
                              />
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              md={4}
                              lg={3}
                              sx={styles.markLeave}
                            >
                              {weekIndex === 0 && (
                                <FormControlLabel
                                  className={classes.setAsDefault}
                                  control={
                                    <Checkbox
                                      id={`thursday[${weekIndex}].setAsDefault`}
                                      name={`thursday[${weekIndex}].setAsDefault`}
                                      value={
                                        formik.values.thursday[weekIndex]
                                          .setAsDefault
                                      }
                                      checked={
                                        formik.values.thursday[weekIndex]
                                          .setAsDefault
                                      }
                                      disabled={disableDefaultCheck}
                                      sx={{ fontSize: "12px" }}
                                    />
                                  }
                                  label={
                                    <Typography variant="body2">
                                      Set As Default
                                    </Typography>
                                  }
                                  onChange={(event: any, newValue: any) => {
                                    formik.setFieldValue(
                                      `thursday[${weekIndex}].setAsDefault`,
                                      newValue
                                    );
                                    if (
                                      !formik.values.thursday[weekIndex]
                                        .setAsDefault === true
                                    ) {
                                      setOpen(true);
                                      setAllDefault(
                                        formik.values.thursday[weekIndex]
                                      );
                                    }
                                    !formik.values.thursday[weekIndex]
                                      .setAsDefault === true &&
                                      ResetNonDefault(arrayHelpers);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                              )}
                              <Stack sx={{ flexDirection: "row" }}>
                                {weekIndex !== 0 && (
                                  <DeleteForeverOutlinedIcon
                                    sx={{ marginTop: "10px" }}
                                    color="error"
                                    onClick={() => {
                                      arrayHelpers.form.values.thursday
                                        .length !== 1
                                        ? arrayHelpers.remove(weekIndex)
                                        : arrayHelpers.remove(1);
                                    }}
                                  />
                                )}
                                {weekIndex === 0 && (
                                  <ButtonComponent
                                    variant="contained"
                                    size="small"
                                    type="reset"
                                    label="Mark as leave"
                                    buttonclass={classes.resetButton}
                                    onClick={() => {
                                      formik.setFieldValue(
                                        `thursday[${weekIndex}].isLeave`,
                                        true
                                      );
                                      ResetSelectedValue(
                                        formik,
                                        weekIndex,
                                        "thursday"
                                      );
                                    }}
                                  />
                                )}
                              </Stack>
                            </Grid>
                          </Fragment>
                        );
                      }
                    )}

                    <Grid
                      item
                      xs={12}
                      md={12}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "10px",
                      }}
                    >
                      {formik.values.thursday[0].setAsDefault === false &&
                        formik.values.thursday[0].isLeave === false && (
                          <ButtonComponent
                            buttonclass={globalClasses.addButton}
                            sx={{
                              maxWidth: "50px !importanat",
                              display:
                                arrayHelpers?.form?.values?.thursday?.length <=
                                1
                                  ? "block"
                                  : "none",
                            }}
                            variant="contained"
                            label="Add"
                            onClick={(e: any) => {
                              e.preventDefault();
                              arrayHelpers.form.values.thursday.length <= 1 &&
                                arrayHelpers.push({
                                  thursdayId: nanoid(),
                                  isLeave: false,
                                  numberOfAppointment: "",
                                  duration: "",
                                  startTime: "",
                                  endTime: "",
                                  setAsDefault: false,
                                });
                            }}
                          />
                        )}
                    </Grid>
                  </>
                )}
              />
            </Grid>
          </form>
        </FormikProvider>

        {/** Friday tab field array and add shedule code  */}

        <FormikProvider value={formik}>
          <form>
            <Grid container columnSpacing={2} rowGap={2} sx={styles.tab}>
              <Grid item xs={12} sm={12} md={12} lg={1} sx={styles.day}>
                <Typography sx={styles.dayText}>Friday</Typography>
              </Grid>
              <FieldArray
                name="friday"
                render={(arrayHelpers) => (
                  <>
                    {formik.values.friday.map((friday: any, weekIndex: any) => {
                      /** This function is used to set default values to other tabs when you select checkbox of setAs default */
                      const setAllDefault = (value: any) => {
                        SetAllDefaultTab(formik, value, weekIndex, 4);
                      };
                      return (
                        <Fragment key={friday.fridayId}>
                          {weekIndex !== 0 && (
                            <Grid item xs={12} sm={12} md={12} lg={1}></Grid>
                          )}
                          <Grid item xs={12} sm={6} md={4} lg={2}>
                            <InputField
                              id={`friday[${weekIndex}].numberOfAppointment`}
                              name={`friday[${weekIndex}].numberOfAppointment`}
                              label="No of appointments"
                              isrequired={true}
                              inputvalues={
                                formik.values.friday[weekIndex]
                                  .numberOfAppointment
                              }
                              changeevent={(event: any) => {
                                formik.handleChange(
                                  `friday[${weekIndex}].numberOfAppointment`
                                )(event);
                                formik.setFieldValue(
                                  `friday[${weekIndex}].setAsDefault`,
                                  false
                                );
                                formik.setFieldValue(
                                  `friday[${weekIndex}].isLeave`,
                                  false
                                );
                              }}
                              blurevent={formik.handleBlur}
                              errormessage={isError(
                                `friday[${weekIndex}].numberOfAppointment`
                              )}
                            />
                            {formik?.values?.friday[weekIndex]
                              ?.numberOfAppointment === "" &&
                              isError(
                                `friday[${weekIndex}].numberOfAppointment`
                              ) && (
                                <Typography sx={styles.errorMessage}>
                                  <ErrorMessage
                                    name={`friday[${weekIndex}].numberOfAppointment`}
                                  />
                                </Typography>
                              )}
                          </Grid>
                          <Grid item xs={12} sm={6} md={4} lg={2}>
                            <SelectField
                              id={`friday[${weekIndex}].duration`}
                              name={`friday[${weekIndex}].duration`}
                              headerText="Duration(min)"
                              label="Select Duration"
                              isrequired={true}
                              value={formik.values.friday[weekIndex].duration}
                              blurevent={formik.handleBlur}
                              changeevent={(event: any) => {
                                formik.handleChange(
                                  `friday[${weekIndex}].duration`
                                )(event);
                                formik.setFieldValue(
                                  `friday[${weekIndex}].setAsDefault`,
                                  false
                                );
                                formik.setFieldValue(
                                  `friday[${weekIndex}].isLeave`,
                                  false
                                );
                              }}
                              options={TIMINGSLOTDURATION}
                              error={
                                formik?.values?.friday[weekIndex]?.duration ===
                                  "" && isError(`friday[${weekIndex}].duration`)
                              }
                            />
                            {formik?.values?.friday[weekIndex]?.duration ===
                              "" &&
                              isError(`friday[${weekIndex}].duration`) && (
                                <Typography sx={styles.errorMessage}>
                                  <ErrorMessage
                                    name={`friday[${weekIndex}].duration`}
                                  />
                                </Typography>
                              )}
                          </Grid>
                          <Grid item xs={12} sm={6} md={4} lg={2}>
                            <TimeComponent
                              label="Start Time"
                              isrequired={true}
                              value={formik.values.friday[weekIndex].startTime}
                              onChange={(newValue: any) => {
                                formik.setFieldValue(
                                  `friday[${weekIndex}].startTime`,
                                  newValue
                                );
                                formik.setFieldValue(
                                  `friday[${weekIndex}].setAsDefault`,
                                  false
                                );
                                formik.setFieldValue(
                                  `friday[${weekIndex}].isLeave`,
                                  false
                                );
                              }}
                              error={
                                getIn(
                                  formik.touched,
                                  `friday[${weekIndex}].startTime`
                                ) &&
                                getIn(
                                  formik.errors,
                                  `friday[${weekIndex}].startTime`
                                )
                              }
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4} lg={2}>
                            <TimeComponent
                              label="End Time"
                              isrequired={true}
                              value={formik.values.friday[weekIndex].endTime}
                              onChange={(newValue: any) => {
                                formik.setFieldValue(
                                  `friday[${weekIndex}].endTime`,
                                  newValue
                                );
                                formik.setFieldValue(
                                  `friday[${weekIndex}].isLeave`,
                                  false
                                );
                                setDisableDefaultCheck(true);
                              }}
                              onClose={(event: any) => {
                                formik.setFieldValue(
                                  `friday[${weekIndex}].setAsDefault`,
                                  false
                                );

                                setDisableDefaultCheck(false);
                              }}
                              error={
                                getIn(
                                  formik.touched,
                                  `friday[${weekIndex}].endTime`
                                ) &&
                                getIn(
                                  formik.errors,
                                  `friday[${weekIndex}].endTime`
                                )
                              }
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={4}
                            lg={3}
                            sx={styles.markLeave}
                          >
                            {weekIndex === 0 && (
                              <FormControlLabel
                                className={classes.setAsDefault}
                                control={
                                  <Checkbox
                                    id={`friday[${weekIndex}].setAsDefault`}
                                    name={`friday[${weekIndex}].setAsDefault`}
                                    value={
                                      formik.values.friday[weekIndex]
                                        .setAsDefault
                                    }
                                    checked={
                                      formik.values.friday[weekIndex]
                                        .setAsDefault
                                    }
                                    disabled={disableDefaultCheck}
                                    sx={{ fontSize: "12px" }}
                                  />
                                }
                                label={
                                  <Typography variant="body2">
                                    Set As Default
                                  </Typography>
                                }
                                onChange={(event: any, newValue: any) => {
                                  formik.setFieldValue(
                                    `friday[${weekIndex}].setAsDefault`,
                                    newValue
                                  );
                                  if (
                                    !formik.values.friday[weekIndex]
                                      .setAsDefault === true
                                  ) {
                                    setOpen(true);
                                    setAllDefault(
                                      formik.values.friday[weekIndex]
                                    );
                                  }
                                  !formik.values.friday[weekIndex]
                                    .setAsDefault === true &&
                                    ResetNonDefault(arrayHelpers);
                                }}
                                onBlur={formik.handleBlur}
                              />
                            )}
                            <Stack sx={{ flexDirection: "row" }}>
                              {weekIndex !== 0 && (
                                <DeleteForeverOutlinedIcon
                                  sx={{ marginTop: "10px" }}
                                  color="error"
                                  onClick={() => {
                                    arrayHelpers.form.values.friday.length !== 1
                                      ? arrayHelpers.remove(weekIndex)
                                      : arrayHelpers.remove(1);
                                  }}
                                />
                              )}
                              {weekIndex === 0 && (
                                <ButtonComponent
                                  variant="contained"
                                  size="small"
                                  type="reset"
                                  label="Mark as leave"
                                  buttonclass={classes.resetButton}
                                  onClick={() => {
                                    formik.setFieldValue(
                                      `friday[${weekIndex}].isLeave`,
                                      true
                                    );
                                    ResetSelectedValue(
                                      formik,
                                      weekIndex,
                                      "friday"
                                    );
                                  }}
                                />
                              )}
                            </Stack>
                          </Grid>
                        </Fragment>
                      );
                    })}

                    <Grid
                      item
                      xs={12}
                      md={12}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "10px",
                      }}
                    >
                      {formik.values.friday[0].setAsDefault === false &&
                        formik.values.friday[0].isLeave === false && (
                          <ButtonComponent
                            buttonclass={globalClasses.addButton}
                            sx={{
                              maxWidth: "50px !importanat",
                              display:
                                arrayHelpers?.form?.values?.friday?.length <= 1
                                  ? "block"
                                  : "none",
                            }}
                            variant="contained"
                            label="Add"
                            onClick={(e: any) => {
                              e.preventDefault();
                              arrayHelpers.form.values.friday.length <= 1 &&
                                arrayHelpers.push({
                                  fridayId: nanoid(),
                                  isLeave: false,
                                  numberOfAppointment: "",
                                  duration: "",
                                  startTime: "",
                                  endTime: "",
                                  setAsDefault: false,
                                });
                            }}
                          />
                        )}
                    </Grid>
                  </>
                )}
              />
            </Grid>
          </form>
        </FormikProvider>

        {/** Saturday tab field array and add shedule code  */}

        <FormikProvider value={formik}>
          <form>
            <Grid container columnSpacing={2} rowGap={2} sx={styles.tab}>
              <Grid item xs={12} sm={12} md={12} lg={1} sx={styles.day}>
                <Typography sx={styles.dayText}>Saturday</Typography>
              </Grid>
              <FieldArray
                name="saturday"
                render={(arrayHelpers) => (
                  <>
                    {formik.values.saturday.map(
                      (saturday: any, weekIndex: any) => {
                        /** This function is used to set default values to other tabs when you select checkbox of setAs default */
                        const setAllDefault = (value: any) => {
                          SetAllDefaultTab(formik, value, weekIndex, 5);
                        };
                        return (
                          <Fragment key={saturday.saturdayId}>
                            {weekIndex !== 0 && (
                              <Grid item xs={12} sm={12} md={12} lg={1}></Grid>
                            )}
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                              <InputField
                                id={`saturday[${weekIndex}].numberOfAppointment`}
                                name={`saturday[${weekIndex}].numberOfAppointment`}
                                label="No of appointments"
                                isrequired={true}
                                inputvalues={
                                  formik.values.saturday[weekIndex]
                                    .numberOfAppointment
                                }
                                changeevent={(event: any) => {
                                  formik.handleChange(
                                    `saturday[${weekIndex}].numberOfAppointment`
                                  )(event);
                                  formik.setFieldValue(
                                    `saturday[${weekIndex}].setAsDefault`,
                                    false
                                  );
                                  formik.setFieldValue(
                                    `saturday[${weekIndex}].isLeave`,
                                    false
                                  );
                                }}
                                blurevent={formik.handleBlur}
                                errormessage={isError(
                                  `saturday[${weekIndex}].numberOfAppointment`
                                )}
                              />
                              {formik?.values?.saturday[weekIndex]
                                ?.numberOfAppointment === "" &&
                                isError(
                                  `saturday[${weekIndex}].numberOfAppointment`
                                ) && (
                                  <Typography sx={styles.errorMessage}>
                                    <ErrorMessage
                                      name={`saturday[${weekIndex}].numberOfAppointment`}
                                    />
                                  </Typography>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                              <SelectField
                                id={`saturday[${weekIndex}].duration`}
                                name={`saturday[${weekIndex}].duration`}
                                headerText="Duration(min)"
                                label="Select Duration"
                                isrequired={true}
                                value={
                                  formik.values.saturday[weekIndex].duration
                                }
                                blurevent={formik.handleBlur}
                                changeevent={(event: any) => {
                                  formik.handleChange(
                                    `saturday[${weekIndex}].duration`
                                  )(event);
                                  formik.setFieldValue(
                                    `saturday[${weekIndex}].setAsDefault`,
                                    false
                                  );
                                  formik.setFieldValue(
                                    `saturday[${weekIndex}].isLeave`,
                                    false
                                  );
                                }}
                                options={TIMINGSLOTDURATION}
                                error={
                                  formik?.values?.saturday[weekIndex]
                                    ?.duration === "" &&
                                  isError(`saturday[${weekIndex}].duration`)
                                }
                              />
                              {formik?.values?.saturday[weekIndex]?.duration ===
                                "" &&
                                isError(`saturday[${weekIndex}].duration`) && (
                                  <Typography sx={styles.errorMessage}>
                                    <ErrorMessage
                                      name={`saturday[${weekIndex}].duration`}
                                    />
                                  </Typography>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                              <TimeComponent
                                label="Start Time"
                                isrequired={true}
                                value={
                                  formik.values.saturday[weekIndex].startTime
                                }
                                onChange={(newValue: any) => {
                                  formik.setFieldValue(
                                    `saturday[${weekIndex}].startTime`,
                                    newValue
                                  );
                                  formik.setFieldValue(
                                    `saturday[${weekIndex}].setAsDefault`,
                                    false
                                  );
                                  formik.setFieldValue(
                                    `saturday[${weekIndex}].isLeave`,
                                    false
                                  );
                                }}
                                error={
                                  getIn(
                                    formik.touched,
                                    `saturday[${weekIndex}].startTime`
                                  ) &&
                                  getIn(
                                    formik.errors,
                                    `saturday[${weekIndex}].startTime`
                                  )
                                }
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                              <TimeComponent
                                label="End Time"
                                isrequired={true}
                                value={
                                  formik.values.saturday[weekIndex].endTime
                                }
                                onChange={(newValue: any) => {
                                  formik.setFieldValue(
                                    `saturday[${weekIndex}].endTime`,
                                    newValue
                                  );
                                  formik.setFieldValue(
                                    `saturday[${weekIndex}].isLeave`,
                                    false
                                  );
                                  setDisableDefaultCheck(true);
                                }}
                                onClose={(event: any) => {
                                  formik.setFieldValue(
                                    `saturday[${weekIndex}].setAsDefault`,
                                    false
                                  );
                                  setDisableDefaultCheck(false);
                                }}
                                error={
                                  getIn(
                                    formik.touched,
                                    `saturday[${weekIndex}].endTime`
                                  ) &&
                                  getIn(
                                    formik.errors,
                                    `saturday[${weekIndex}].endTime`
                                  )
                                }
                              />
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              md={4}
                              lg={3}
                              sx={styles.markLeave}
                            >
                              {weekIndex === 0 && (
                                <FormControlLabel
                                  className={classes.setAsDefault}
                                  control={
                                    <Checkbox
                                      id={`saturday[${weekIndex}].setAsDefault`}
                                      name={`saturday[${weekIndex}].setAsDefault`}
                                      value={
                                        formik.values.saturday[weekIndex]
                                          .setAsDefault
                                      }
                                      checked={
                                        formik.values.saturday[weekIndex]
                                          .setAsDefault
                                      }
                                      disabled={disableDefaultCheck}
                                      sx={{ fontSize: "12px" }}
                                    />
                                  }
                                  label={
                                    <Typography variant="body2">
                                      Set As Default
                                    </Typography>
                                  }
                                  onChange={(event: any, newValue: any) => {
                                    formik.setFieldValue(
                                      `saturday[${weekIndex}].setAsDefault`,
                                      newValue
                                    );
                                    if (
                                      !formik.values.saturday[weekIndex]
                                        .setAsDefault === true
                                    ) {
                                      setOpen(true);
                                      setAllDefault(
                                        formik.values.saturday[weekIndex]
                                      );
                                    }
                                    !formik.values.saturday[weekIndex]
                                      .setAsDefault === true &&
                                      ResetNonDefault(arrayHelpers);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                              )}
                              <Stack sx={{ flexDirection: "row" }}>
                                {weekIndex !== 0 && (
                                  <DeleteForeverOutlinedIcon
                                    sx={{ marginTop: "10px" }}
                                    color="error"
                                    onClick={() => {
                                      arrayHelpers.form.values.saturday
                                        .length !== 1
                                        ? arrayHelpers.remove(weekIndex)
                                        : arrayHelpers.remove(1);
                                    }}
                                  />
                                )}
                                {weekIndex === 0 && (
                                  <ButtonComponent
                                    variant="contained"
                                    size="small"
                                    type="reset"
                                    label="Mark as leave"
                                    buttonclass={classes.resetButton}
                                    onClick={() => {
                                      formik.setFieldValue(
                                        `saturday[${weekIndex}].isLeave`,
                                        true
                                      );
                                      ResetSelectedValue(
                                        formik,
                                        weekIndex,
                                        "saturday"
                                      );
                                    }}
                                  />
                                )}
                              </Stack>
                            </Grid>
                          </Fragment>
                        );
                      }
                    )}

                    <Grid
                      item
                      xs={12}
                      md={12}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "10px",
                      }}
                    >
                      {formik.values.saturday[0].setAsDefault === false &&
                        formik.values.saturday[0].isLeave === false && (
                          <ButtonComponent
                            buttonclass={globalClasses.addButton}
                            sx={{
                              maxWidth: "50px !importanat",
                              display:
                                arrayHelpers?.form?.values?.saturday?.length <=
                                1
                                  ? "block"
                                  : "none",
                            }}
                            variant="contained"
                            label="Add"
                            onClick={(e: any) => {
                              e.preventDefault();
                              arrayHelpers.form.values.saturday.length <= 1 &&
                                arrayHelpers.push({
                                  saturdayId: nanoid(),
                                  isLeave: false,
                                  numberOfAppointment: "",
                                  duration: "",
                                  startTime: "",
                                  endTime: "",
                                  setAsDefault: false,
                                });
                            }}
                          />
                        )}
                    </Grid>
                  </>
                )}
              />
            </Grid>
          </form>
        </FormikProvider>

        {/** Sunday tab field array and add shedule code  */}

        <FormikProvider value={formik}>
          <form>
            <Grid container columnSpacing={2} rowGap={2} sx={styles.tab}>
              <Grid item xs={12} sm={12} md={12} lg={1} sx={styles.day}>
                <Typography sx={styles.dayText}>Sunday</Typography>
              </Grid>
              <FieldArray
                name="sunday"
                render={(arrayHelpers) => (
                  <>
                    {formik.values.sunday.map((sunday: any, weekIndex: any) => {
                      /** This function is used to set default values to other tabs when you select checkbox of setAs default */
                      const setAllDefault = (value: any) => {
                        SetAllDefaultTab(formik, value, weekIndex, 6);
                      };
                      return (
                        <Fragment key={sunday.sundayId}>
                          {weekIndex !== 0 && (
                            <Grid item xs={12} sm={12} md={12} lg={1}></Grid>
                          )}
                          <Grid item xs={12} sm={6} md={4} lg={2}>
                            <InputField
                              id={`sunday[${weekIndex}].numberOfAppointment`}
                              name={`sunday[${weekIndex}].numberOfAppointment`}
                              label="No of appointments"
                              isrequired={true}
                              inputvalues={
                                formik.values.sunday[weekIndex]
                                  .numberOfAppointment
                              }
                              changeevent={(event: any) => {
                                formik.handleChange(
                                  `sunday[${weekIndex}].numberOfAppointment`
                                )(event);
                                formik.setFieldValue(
                                  `sunday[${weekIndex}].setAsDefault`,
                                  false
                                );
                                formik.setFieldValue(
                                  `sunday[${weekIndex}].isLeave`,
                                  false
                                );
                              }}
                              blurevent={formik.handleBlur}
                              errormessage={isError(
                                `sunday[${weekIndex}].numberOfAppointment`
                              )}
                            />
                            {formik?.values?.sunday[weekIndex]
                              ?.numberOfAppointment === "" &&
                              isError(
                                `sunday[${weekIndex}].numberOfAppointment`
                              ) && (
                                <Typography sx={styles.errorMessage}>
                                  <ErrorMessage
                                    name={`sunday[${weekIndex}].numberOfAppointment`}
                                  />
                                </Typography>
                              )}
                          </Grid>
                          <Grid item xs={12} sm={6} md={4} lg={2}>
                            <SelectField
                              id={`sunday[${weekIndex}].duration`}
                              name={`sunday[${weekIndex}].duration`}
                              headerText="Duration(min)"
                              label="Select Duration"
                              isrequired={true}
                              value={formik.values.sunday[weekIndex].duration}
                              blurevent={formik.handleBlur}
                              changeevent={(event: any) => {
                                formik.handleChange(
                                  `sunday[${weekIndex}].duration`
                                )(event);
                                formik.setFieldValue(
                                  `sunday[${weekIndex}].setAsDefault`,
                                  false
                                );
                                formik.setFieldValue(
                                  `sunday[${weekIndex}].isLeave`,
                                  false
                                );
                              }}
                              options={TIMINGSLOTDURATION}
                              error={
                                formik?.values?.sunday[weekIndex]?.duration ===
                                  "" && isError(`sunday[${weekIndex}].duration`)
                              }
                            />
                            {formik?.values?.sunday[weekIndex]?.duration ===
                              "" &&
                              isError(`sunday[${weekIndex}].duration`) && (
                                <Typography sx={styles.errorMessage}>
                                  <ErrorMessage
                                    name={`sunday[${weekIndex}].duration`}
                                  />
                                </Typography>
                              )}
                          </Grid>
                          <Grid item xs={12} sm={6} md={4} lg={2}>
                            <TimeComponent
                              label="Start Time"
                              isrequired={true}
                              value={formik.values.sunday[weekIndex].startTime}
                              onChange={(newValue: any) => {
                                formik.setFieldValue(
                                  `sunday[${weekIndex}].startTime`,
                                  newValue
                                );
                                formik.setFieldValue(
                                  `sunday[${weekIndex}].setAsDefault`,
                                  false
                                );
                                formik.setFieldValue(
                                  `sunday[${weekIndex}].isLeave`,
                                  false
                                );
                              }}
                              error={
                                getIn(
                                  formik.touched,
                                  `sunday[${weekIndex}].startTime`
                                ) &&
                                getIn(
                                  formik.errors,
                                  `sunday[${weekIndex}].startTime`
                                )
                              }
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4} lg={2}>
                            <TimeComponent
                              label="End Time"
                              isrequired={true}
                              value={formik.values.sunday[weekIndex].endTime}
                              onChange={(newValue: any) => {
                                formik.setFieldValue(
                                  `sunday[${weekIndex}].endTime`,
                                  newValue
                                );
                                formik.setFieldValue(
                                  `sunday[${weekIndex}].isLeave`,
                                  false
                                );
                                setDisableDefaultCheck(true);
                              }}
                              onClose={(event: any) => {
                                formik.setFieldValue(
                                  `sunday[${weekIndex}].setAsDefault`,
                                  false
                                );

                                setDisableDefaultCheck(false);
                              }}
                              error={
                                getIn(
                                  formik.touched,
                                  `sunday[${weekIndex}].endTime`
                                ) &&
                                getIn(
                                  formik.errors,
                                  `sunday[${weekIndex}].endTime`
                                )
                              }
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={4}
                            lg={3}
                            sx={styles.markLeave}
                          >
                            {weekIndex === 0 && (
                              <FormControlLabel
                                className={classes.setAsDefault}
                                control={
                                  <Checkbox
                                    id={`sunday[${weekIndex}].setAsDefault`}
                                    name={`sunday[${weekIndex}].setAsDefault`}
                                    value={
                                      formik.values.sunday[weekIndex]
                                        .setAsDefault
                                    }
                                    checked={
                                      formik.values.sunday[weekIndex]
                                        .setAsDefault
                                    }
                                    disabled={disableDefaultCheck}
                                    sx={{ fontSize: "12px" }}
                                  />
                                }
                                label={
                                  <Typography variant="body2">
                                    Set As Default
                                  </Typography>
                                }
                                onChange={(event: any, newValue: any) => {
                                  formik.setFieldValue(
                                    `sunday[${weekIndex}].setAsDefault`,
                                    newValue
                                  );
                                  if (
                                    !formik.values.sunday[weekIndex]
                                      .setAsDefault === true
                                  ) {
                                    setOpen(true);
                                    setAllDefault(
                                      formik.values.sunday[weekIndex]
                                    );
                                  }
                                  !formik.values.sunday[weekIndex]
                                    .setAsDefault === true &&
                                    ResetNonDefault(arrayHelpers);
                                }}
                                onBlur={formik.handleBlur}
                              />
                            )}
                            <Stack sx={{ flexDirection: "row" }}>
                              {weekIndex !== 0 && (
                                <DeleteForeverOutlinedIcon
                                  sx={{ marginTop: "10px" }}
                                  color="error"
                                  onClick={() => {
                                    arrayHelpers.form.values.sunday.length !== 1
                                      ? arrayHelpers.remove(weekIndex)
                                      : arrayHelpers.remove(1);
                                  }}
                                />
                              )}
                              {weekIndex === 0 && (
                                <ButtonComponent
                                  variant="contained"
                                  size="small"
                                  type="reset"
                                  label="Mark as leave"
                                  buttonclass={classes.resetButton}
                                  onClick={() => {
                                    formik.setFieldValue(
                                      `sunday[${weekIndex}].isLeave`,
                                      true
                                    );
                                    ResetSelectedValue(
                                      formik,
                                      weekIndex,
                                      "sunday"
                                    );
                                  }}
                                />
                              )}
                            </Stack>
                          </Grid>
                        </Fragment>
                      );
                    })}

                    <Grid
                      item
                      xs={12}
                      md={12}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "10px",
                      }}
                    >
                      {formik.values.sunday[0].setAsDefault === false &&
                        formik.values.sunday[0].isLeave === false && (
                          <ButtonComponent
                            buttonclass={globalClasses.addButton}
                            sx={{
                              maxWidth: "50px !importanat",
                              display:
                                arrayHelpers?.form?.values?.sunday?.length <= 1
                                  ? "block"
                                  : "none",
                            }}
                            variant="contained"
                            label="Add"
                            onClick={(e: any) => {
                              e.preventDefault();
                              arrayHelpers.form.values.sunday.length <= 1 &&
                                arrayHelpers.push({
                                  sundayId: nanoid(),
                                  isLeave: false,
                                  numberOfAppointment: "",
                                  duration: "",
                                  startTime: "",
                                  endTime: "",
                                  setAsDefault: false,
                                });
                            }}
                          />
                        )}
                    </Grid>
                  </>
                )}
              />
            </Grid>
          </form>
        </FormikProvider>
      </Grid>
      {/** Desktop tab end  */}
      {open && (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: 1500,
            display: "flex",
            flexDirection: "column",
          }}
          open
        >
          <Typography fontWeight="600" fontSize="20px">
            Setting default hp schedule timings...!
          </Typography>
          <CircularProgress color="primary" sx={{ margin: "20px" }} />
        </Backdrop>
      )}
    </>
  );
};

export default HpScheduleTimings;

const styles = {
  tabClass: {
    backgroundColor: "#b9b9b9 !important",
    minWidth: "14.3%",
    color: "#ffffff !important",
    "&.Mui-selected": {
      backgroundColor: "#006699 !important",
    },
  },
  errorMessage: {
    fontSize: "12px",
    color: "#d32f2f",
    padding: "5px",
  },
  markLeave: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
  },
  alignItem: { display: "flex", alignItems: "center" },
  tab: { boxShadow: 1, margin: "0px", padding: "10px" },
  day: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#EBF1F7",
    borderRadius: "10px",
    padding: "5px",
  },
  dayText: {
    color: "#3755BF",
    fontWeight: "600",
    ml: "-5px",
    fontSize: "14px",
  },
};
